<template>
  <div class="bb-contact-soa-invoices">
    <div class="bb-contact-soa-invoices__icon"
         @click.stop="openListInvoice">
      <CheckListIcon/>
    </div>
   <transition name="slide-select">
     <VuePerfectScrollbar class="bb-contact-soa-invoices-list"
                          :class="{'bb-contact-soa-invoices-list_top': editSoaIndex === 0 || newSoa}"
                          v-if="openList"
                          :settings="{wheelPropagation: false}">
       <div class="bb-contact-soa-invoices-list-item"
            @click="setInvoice(invoice)"
            v-for="invoice in invoices"
            :key="invoice._id">
         <radio name="invoice"
                :value="invoice"
                :checked="invoice.$checked"
                @radioChange="setInvoice"/>
         <div class="bb-contact-soa-invoices-list-item__number"> {{ invoice.number }}</div>
       </div>
     </VuePerfectScrollbar>
   </transition>
    <transition name="slide-select">
      <VuePerfectScrollbar class="bb-contact-soa-invoices-list bb-contact-soa-invoices-list_left"
                           @keyup.enter="createSoa"
                           :class="{'bb-contact-soa-invoices-list_top': editSoaIndex === 0 || newSoa}"
                           v-if="openServiceList"
                           :settings="{wheelPropagation: false}"
      >
        <div v-for="service in serviceInvoice"
             :key="service._id"
        >
          <checkbox name="service"
                    :value="service.isCheck"
                    :animation="true"
                    :topPosition="true"
                    @checkboxChange="setService(service)"
          >
            <div class="bb-contact-soa-invoices-list-item
                        bb-contact-soa-invoices-list-item_service">
              <div>
                {{getNameCategory(service, service.category)}} re.
              </div>
              <div class="bb-contact-soa-invoices-list-item_name"
                   ref="serviceName"
                   @mouseenter="handlerMouseEnter(service, $event)"
                   @mouseleave="showName = false"
              >
                {{service.name}}
                <transition name="fade" mode="out-in">
                  <div v-if="showName === service._id"
                       :style="openPopup"
                       class="bb-contact-soa-invoices-popup"
                  >
                    <span class="bb-contact-soa-invoices-popup__text">
                      {{service.name}}
                    </span>
                  </div>
                </transition>
              </div>
              <input class="bb-input bb-input_border"
                     :class="{'bb-input_error': service.inputError}"
                     v-autofocus
                     v-model="service.balance"
                     @focus="focusBalance(service)"
                     @input="inputBalance(service)"
              >
            </div>
          </checkbox>
        </div>
      </VuePerfectScrollbar>
      <VuePerfectScrollbar class="bb-contact-soa-invoices-list bb-contact-soa-invoices-list_left"
                           :class="{'bb-contact-soa-invoices-list_top': editSoaIndex === 0 || newSoa}"
                           v-else-if="openInvoiceList && invoicesOverPaid.length > 0"
                           :settings="{wheelPropagation: false}"
      >
        <div v-for="overPaidInvoice in invoicesOverPaid"
             :key="overPaidInvoice._id"
             class="bb-contact-soa-invoices-list-item
                    bb-contact-soa-invoices-list-item_overpaid"
             @click="setOverPaidInvoice(overPaidInvoice)"
        >
          <radio name="overPaidInvoice"
                 :value="overPaidInvoice"
                 :checked="overPaidInvoice.$checked"
                 @radioChange="setOverPaidInvoice"/>
          <div>{{overPaidInvoice.number}}</div>
          <div class="bb-contact-soa-invoices-list-item_end">
            {{numeralConvertNumber(overPaidInvoice.openOverPaid)}}
          </div>
        </div>
      </VuePerfectScrollbar>
    </transition>
  </div>
</template>

<script>
import InvoicesApi from '@/api/Invoce/api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import CheckListIcon from '@/components/Main/Icons/CheckListIcon'
import radio from '@/components/Main/Inputs/radio'
import Checkbox from '@/components/Main/Inputs/checkbox'
import convertNumber from '@/mixin/convertNumber'
import {find, get, findIndex} from 'lodash'
import serviceCategoriesList from '@/mixin/serviceCategoriesList'

export default {
  name: 'ContactSoaInvoices',
  mixins: [convertNumber, serviceCategoriesList],
  components: {
    Checkbox,
    VuePerfectScrollbar,
    CheckListIcon,
    radio
  },
  props: ['client', 'soa', 'editSoaIndex', 'newSoa'],
  data: function () {
    return {
      openList: false,
      openServiceList: false,
      openInvoiceList: false,
      selectedInvoice: {},
      services: [],
      invoices: [],
      balanceOpen: [],
      showName: false,
      openPopup: {
        left: 0,
        top: 0
      },
      overPaidInvoice: {},
      balance: 0,
      openService: {
        left: 0
      }
    }
  },
  computed: {
    checkedInvoices () {
      return this.invoices.find(item => item.$checked)
    },
    serviceInvoice: {
      get: function () {
        return get(this.checkedInvoices, 'services', [])
      },
      set: function (data) {
        this.checkedInvoices.services = data
        return this.checkedInvoices.services
      }
    },
    invoicesOverPaid () {
      return this.overPaidInvoices || []
    },
    serviceCategories: {
      get: function () {
        return this.$store.getters.serviceCategories
      },
      set: function (data) {
        this.$store.dispatch('setServiceCategories', data)
      }
    },
    clientId() {
      return this.$store.getters.clientInfo.id
    }
  },
  methods: {
    setInvoice (val) {
      if (val.$checked) return
      this.invoices.forEach(item => {
        this.$set(item, '$checked', item._id === val._id)
      })
      if (val._id === 'misc' || val._id === 'payment') {
        this.openList = false
        this.openServiceList = false
        this.openInvoiceList = false
        this.$emit('change', {invoice: val})
        return
      }
      if (val._id === 'overpaid') {
        if (this.invoicesOverPaid.length === 0) return
        this.openInvoiceList = true
        this.openServiceList = false
        this.invoicesOverPaid[0].$checked = true
        this.overPaidInvoice = val
        this.$emit('change', {invoice: this.invoicesOverPaid[0], overPaid: val})
        return
      }
      this.openInvoiceList = false
      this.serviceInvoice.forEach(service => this.$set(service, 'isCheck', false))
      this.openServiceList = true
      this.selectedInvoice = val
      this.$emit('change', {invoice: val})
    },
    checkChoseOverPaid (id) {
      if (id === 'overpaid') {
        this.openInvoiceList = true
        const invoiceId = get(this.soa, ['invoice', 'id'], '')
        const invoiceOverPaid = get(this.soa, ['invoice', '_id'], invoiceId)
        this.invoicesOverPaid.forEach(item => {
          this.$set(item, '$checked', item._id === invoiceOverPaid)
        })
        this.overPaidInvoice = this.checkedInvoices
        return
      }
      this.openInvoiceList = false
    },
    createSoa () {
      this.$emit('createSoa')
    },
    inputBalance (item) {
      if (typeof item.balance === 'string') {
        item.balance = item.balance.replace(/[^\d.-]/g, '')
      }
      const balance = +get(item, 'balance', 0)
      if (balance >= 0) {
        item.inputError = false
      } else {
        item.inputError = true
      }
      this.$emit('changeBalance')
    },
    focusBalance (item) {
      if (!item.balance) {
        item.balance = '0'
        this.$emit('changeBalance')
      }
    },
    handlerMouseEnter (service, e) {
      const { name } = service
      const { target } = e
      if (name.length >= 20) {
        const id = get(service, '_id', '')
        this.showName = id
        const popups = get(this.$refs, 'serviceName', '')
        const popupWidth = get(popups[0], 'offsetWidth', 0)
        const diffLeft = popupWidth / 2
        const box = target.getBoundingClientRect()
        this.openPopup = {
          left: (box.left - diffLeft + 5) + 'px',
          top: box.top + 30 + 'px'
        }
      }
    },
    deleteInvoiceAndService () {
      const checkedInvoice = get(this.checkedInvoices, '$checked', false)
      this.openServiceList = false
      if (!checkedInvoice) return
      if (this.serviceInvoice.length === 1 || !this.serviceInvoice.length) {
        this.invoices = this.invoices.filter(item => item._id !== this.checkedInvoices._id)
      }
      if (checkedInvoice && this.serviceInvoice.length) {
        this.openServiceList = true
        const servicesEdit = get(this.soa, 'invoiceService', [])
        if (servicesEdit.length) {
          const servicesId = servicesEdit.map(item => {
            const serviceIdOne = get(item, '_id', item)
            return get(item, 'invoiceServiceId', serviceIdOne)
          })
          const filterService = this.serviceInvoice.filter(item => {
            return !servicesId.includes(item._id)
          })
          this.serviceInvoice = filterService
        }
      }
      this.selectedInvoice = this.checkedInvoices
    },
    openListInvoice () {
      this.openList = !this.openList
      const soaInvoiceIdOne = get(this.soa, ['invoice', 'id'], '')
      const soaInvoiceIdTwo = get(this.soa, ['invoice', '_id'], soaInvoiceIdOne)
      const isMisc = get(this.soa, 'isMisc', false)
      const isNoPaymentInvoice = get(this.soa, 'isNoPaymentInvoice', false)
      const isOverPaidInvoice = get(this.soa, 'isOverPaidInvoice', false)
      if (isMisc || isNoPaymentInvoice || isOverPaidInvoice) {
        const id = isMisc ? 'misc' : isNoPaymentInvoice ? 'payment' : 'overpaid'
        const index = findIndex(this.invoices, {_id: id})
        this.$set(this.invoices[index], '$checked', true)
        this.checkChoseOverPaid(id)
      } else {
        this.invoices.forEach(item => {
          this.$set(item, '$checked', item._id === soaInvoiceIdTwo)
        })
      }
      if (this.openList) {
        if (!this.newSoa) {
          this.deleteInvoiceAndService()
          return
        }
        const checkedInvoice = get(this.checkedInvoices, '$checked', false)
        if (checkedInvoice && this.serviceInvoice.length) {
          this.openServiceList = true
          const servicesEdit = get(this.soa, 'invoiceService', [])
          if (servicesEdit.length) {
            const servicesId = servicesEdit.map(item => {
              const serviceIdOne = get(item, '_id', item)
              return get(item, 'invoiceServiceId', serviceIdOne)
            })
            this.serviceInvoice.forEach(service => {
              service.isCheck = servicesId.includes(service._id)
            })
          }
          this.selectedInvoice = this.checkedInvoices
        }
      } else {
        this.openServiceList = false
        this.openInvoiceList = false
      }
    },
    getCategories () {
      this.serviceCategories = this.serviceCategoriesList
    },
    setService (service) {
      const balance = +get(service, 'balance', 0)
      if (balance < 0) this.$set(service, 'inputError', true)
      this.$set(service, 'isCheck', !service.isCheck)
      if (!service.isCheck) service.inputError = false
      const checkedServices = this.serviceInvoice.filter(item => item.isCheck)
      this.$emit('change', {service: checkedServices, invoice: this.selectedInvoice})
    },
    setOverPaidInvoice (overPaidInvoice) {
      if (overPaidInvoice.$checked) return
      this.invoicesOverPaid.forEach(item => {
        this.$set(item, '$checked', item._id === overPaidInvoice._id)
      })
      this.$emit('change', {invoice: overPaidInvoice, overPaid: this.overPaidInvoice})
      this.openList = false
      this.openInvoiceList = false
    },
    getNameCategory (service, category) {
      let idCategory = service.category || category
      if (service.category === 0) idCategory = 0
      const res = find(this.serviceCategories, item => item.id === idCategory)
      return res ? res.name : ''
    },
    getInvoices () {
      InvoicesApi.getOpenBalance(this.clientId || this.client.id)
        .then(({data: {openBalance, overpaid}}) => {
          this.invoices = openBalance
          this.overPaidInvoices = overpaid
          this.invoices.push(
            {
              _id: 'misc',
              number: 'Bill to client'
            },
            {
              _id: 'payment',
              number: 'Payment (no inv)'
            },
            {
              _id: 'overpaid',
              number: 'Overpaid'
            }
          )
          if (!this.overPaidInvoices.length) this.invoices.pop()
        })
        .catch(e => {
          console.error(e)
        })
    }
  },
  beforeMount () {
    this.getInvoices()
    this.getCategories()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../sass/variables";
@import "../../../../../../sass/mixins";

.bb-contact-soa-invoices {
  position: relative;
  margin-left: -20px;
  @include global-font();

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;
    min-height: 30px;
    margin-left: 10px;
    color: $color-accent;
    background-color: $color-white;
    border-radius: 5px;
    border: 1px solid $color-wild-sand;
    box-sizing: border-box;
    transition: .15s;
    cursor: pointer;
  }

  &-list {
    position: absolute;
    bottom: 34px;
    left: 0;
    padding: 16px 18px;
    background: $color-white;
    box-shadow: 0 0 12px rgba($color-black, 0.12);
    border-radius: 5px;
    overflow: hidden;
    max-height: 170px;
    z-index: 99999;
    user-select: none;
    display: grid;
    grid-gap: 10px;

    &_left {
      left: 200px;
    }

    &_top {
      top: 34px;
      bottom: auto;
    }

    &-item {
      display: grid;
      grid-template-columns: 14px auto;
      align-items: center;
      grid-gap: 9px;
      cursor: pointer;
      transition: 0.3s;

      &_service {
        margin-left: 14px;
        grid-template-columns: minmax(100px, 110px) 122px 90px;
      }

      &_name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &_overpaid {
        grid-template-columns: 14px 150px 90px;
      }

      &_end {
        text-align: end;
      }

      &:hover {
       color: $color-accent;
      }

      &__number {
        font-weight: normal;
        font-size: 15px;
        line-height: 18px;
        white-space: nowrap;
      }
    }
  }

  &-popup {
    display: grid;
    z-index: 2;
    grid-row-gap: 10px;
    position: fixed;
    background: $color-white;
    box-shadow: 0 0 12px rgba($color-black, 0.12);
    border-radius: 5px;
    color: black;
    padding: 12px;
    pointer-events: none;

    &__item {
      display: grid;
      grid-template-columns: 25px auto;
      grid-gap: 6px;
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
      text-transform: capitalize;

      &_weight {
        font-weight: bold;
      }
    }

    &__text {
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
      text-transform: capitalize;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/ContactSoaInvoices.vue